import { useState } from "react"
import { Input } from "reactstrap"
import MainButton from "../../Component/Button/MainButton"
import LoadingScreen from "../../Component/Loader/LoadingScreen"
import { verifyLength } from "../../Service/Helper/Utils"
import { numberContact } from "../../variables"
import logo from "../../public/img/logo.png"
import { useNavigate, useSearchParams } from "react-router-dom"

function ForgotPages() {
    const navigation = useNavigate()
    const [searchParams] = useSearchParams()
    const id = searchParams.get("id") || ""
    const token = searchParams.get("token") || ""
    const [customerId, setCustomerId] = useState(id)
    const [isLoad, setIsLoad] = useState(false)
    const isUseParams = !id
    const hasResetToken = Boolean(token)

    function openSupportChat() {
        const message = customerId
            ? `Halo Admin, saya ingin reset password untuk nomor layanan ${customerId}.`
            : "Halo Admin, saya ingin reset password akun pelanggan."
        window.open(`${numberContact}?text=${encodeURIComponent(message)}`, "_blank")
    }

    function handleClick () {
        if (!customerId) {
            window.alert("Masukkan nomor layanan terlebih dahulu.")
            return
        }

        if (!hasResetToken) {
            openSupportChat()
            return
        }

        setIsLoad(true)
        navigation(`/reset?id=${encodeURIComponent(customerId)}&token=${encodeURIComponent(token)}`)
        setIsLoad(false)
    }

    const children = (
        <main className="public-auth-page">
            <section className="public-auth-hero">
                <div className="landing-container public-auth-grid">
                    <div className="public-auth-copy">
                        <div className="landing-brand-chip">
                            <img src={logo} alt="Goodnet Logo" />
                            <span>Goodnet By Artamedia</span>
                        </div>
                        <h1>Pulihkan akses anda.</h1>
                        <p>Masukkan nomor layanan agar tim dapat membantu reset akses dengan aman tanpa membuka data pelanggan lain.</p>
                        {/* <div className="landing-proof-grid">
                            <div><strong>Aman</strong><span>Reset diverifikasi admin</span></div>
                            <div><strong>Cepat</strong><span>Nomor layanan dipakai sebagai referensi</span></div>
                            <div><strong>Bantuan</strong><span>Terhubung ke WhatsApp support</span></div>
                        </div> */}
                    </div>

                    <div className="public-auth-card">
                        <div className="public-auth-card-head">
                            <span>Lupa password</span>
                            <strong>{hasResetToken ? "Lanjut reset password" : "Minta bantuan reset"}</strong>
                        </div>

                        <div className="public-auth-form">
                            <Input
                                className="public-auth-input"
                                placeholder="Nomor Layanan (10 - 12) Digit"
                                value={customerId}
                                disabled={!isUseParams}
                                onChange={(e) => {
                                    if (!verifyLength(e.target.value, 13)) {
                                        setCustomerId(e.target.value)
                                    }
                                }}
                            />
                        </div>

                        <div className="public-auth-note">
                            {hasResetToken
                                ? "Pastikan Nomor Layanan Anda sesuai"
                                : "Link Reset Password akan di kirimkan secara otomatis"}
                        </div>

                        <div className="public-auth-link-row">
                            <button type="button" onClick={() => navigation("/login")}>
                                Kembali login
                            </button>
                            <button type="button" onClick={() => navigation("/register/new")}>
                                Daftar pemasangan baru
                            </button>
                        </div>

                        <div className="public-auth-actions">
                            <MainButton
                                title={hasResetToken ? "Lanjut Reset" : "Hubungi Admin"}
                                onClick={handleClick}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )

    return (
        <LoadingScreen
            loading={isLoad}
            children={children}
        />
    )
}

export default ForgotPages
